import {
  ImageSkeleton,
  Rating,
  TextSkeleton,
} from "@aqar-app/aqar-design-system";
import styles from "./AuthProfileCard/.module.scss";

const ProfileCardSkeleton = () => {
  return (
    <div className={styles.profileCard}>
      <div className={styles.content}>
        <div className={styles.avatar}>
          <ImageSkeleton
            style={{ borderRadius: "50%", height: "60px", width: "60px" }}
          />
        </div>
        <div className={styles.name}>
          <TextSkeleton line={1} width="100px" />
        </div>
        <div className={styles.rate}>
          <Rating value={0} />
        </div>
        <div className={styles.description}>
          <TextSkeleton line={1} width="200px" height={10} />
        </div>
      </div>
    </div>
  );
};

export default ProfileCardSkeleton;
